<template>
  <BaseScreen v-bind="screen">
    <div
      v-if="isEntertainmentActive"
      class="screen__wait"
      slot="middle"
      data-animation="fadeInBottom"
    >
      <BaseIcon
        name="logo_light"
        class="screen__logo screen__logo_large"
      />
      <BaseButton
        v-bind="cancelButton"
        @click="stopScript"
        class="screen__gap screen__gap_double"
      />
    </div>
    <BaseMenu
      v-else
      :items="menuItems"
    />
  </BaseScreen>
</template>

<script>
import { GLOBAL_EVENTS } from '@/App.vue';

import screenMixin from '@/mixins/screen';
import scriptMixin from '@/mixins/script';

import BaseIcon from '@/components/BaseIcon.vue';
import BaseMenu from '@/components/BaseMenu.vue';
import BaseButton from '@/components/BaseButton.vue';

export const ENTERTAINMENT_NAMES = Object.freeze({
  DANCE: 'DANCE',
  SONG: 'SONG',
  JOKE: 'JOKE',
});

export default {
  name: 'EntertainmentScreen',
  mixins: [screenMixin, scriptMixin],
  components: {
    BaseIcon,
    BaseMenu,
    BaseButton,
  },
  data() {
    return {
      isJokeStarted: false,
      activeEntertainment: null,
    };
  },
  computed: {
    titleText() {
      return this.$t('entertainment.title');
    },
    screenCase() {
      if (this.activeEntertainment === ENTERTAINMENT_NAMES.DANCE) {
        return 'STEP_ENTERTAINMENT_DANCE';
      }
      if (this.activeEntertainment === ENTERTAINMENT_NAMES.SONG) {
        return 'STEP_ENTERTAINMENT_SONG';
      }
      if (this.isJokeEntertainmentActive) {
        return 'STEP_ENTERTAINMENT_JOKE';
      }
      return 'STEP_ENTERTAINMENT';
    },
    isJokeEntertainmentActive() {
      return this.activeEntertainment === ENTERTAINMENT_NAMES.JOKE;
    },
    isEntertainmentActive() {
      return Boolean(this.activeEntertainment && !this.isJokeEntertainmentActive);
    },
    isPatternBackground() {
      return this.isEntertainmentActive;
    },
    isHeaderHidden() {
      return this.isEntertainmentActive;
    },
    isFooterHidden() {
      return this.isEntertainmentActive;
    },
    menuItems() {
      return [
        {
          icon: {
            name: 'dance',
            theme: 'primary',
            size: 'm',
          },
          label: {
            text: this.$t('entertainment.dance'),
            size: 'm',
          },
          action: this.startDance,
        },
        {
          icon: {
            name: 'song',
            theme: 'primary',
            size: 'm',
          },
          label: {
            text: this.$t('entertainment.song'),
            size: 'm',
          },
          action: this.startSong,
        },
        {
          icon: {
            name: 'joke',
            theme: this.isJokeEntertainmentActive ? '' : 'primary',
            size: 'm',
          },
          label: {
            text: this.$t('entertainment.joke'),
            size: 'm',
          },
          action: this.startJoke,
          disabled: this.isJokeEntertainmentActive,
        },
        {
          icon: {
            name: 'photo',
            theme: 'primary',
            size: 'm',
          },
          label: {
            text: this.$t('entertainment.photo'),
            size: 'm',
          },
          action: this.goToPhotoScreen,
        },
      ];
    },
    cancelButton() {
      return {
        text: this.$t('entertainment.cancel'),
        theme: 'secondary',
      };
    },
  },
  created() {
    this.initActions([
      ['ACTION_GO_PHOTO', this.goToPhotoScreen],
      ['ACTION_ENTERTAINMENT_DANCE', this.startDance],
      ['ACTION_ENTERTAINMENT_SONG', this.startSong],
      ['ACTION_ENTERTAINMENT_JOKE', this.startJoke],
      ['ACTION_CANCEL_ENTERTAINMENT', this.stopScript], // функция из миксина
      [GLOBAL_EVENTS.ROBOT_REPLIC_FINISH, this.stopJoke],
    ]);
  },
  methods: {
    clearEntertainment() {
      this.isJokeStarted = false;
      this.activeEntertainment = null;
    },
    startDance() {
      this.abortRobotReplic();
      this.clearEntertainment();
      this.runScript(this.setDanceEntertainment); // функция из миксина
    },
    startSong() {
      this.abortRobotReplic();
      this.clearEntertainment();
      this.runScript(this.setSongEntertainment); // функция из миксина
    },
    startJoke() {
      this.$root.$once(GLOBAL_EVENTS.ROBOT_REPLIC_START, () => {
        this.isJokeStarted = true;
      });
      this.setJokeEntertainment();
    },
    stopJoke() {
      if (this.isJokeStarted) {
        this.clearEntertainment();
      }
    },
    setDanceEntertainment() {
      this.activeEntertainment = ENTERTAINMENT_NAMES.DANCE;
    },
    setSongEntertainment() {
      this.activeEntertainment = ENTERTAINMENT_NAMES.SONG;
    },
    setJokeEntertainment() {
      this.activeEntertainment = ENTERTAINMENT_NAMES.JOKE;
    },
    abortRobotReplic() {
      return this.$robot.dialogService.abortRobotReplic();
    },
    onScriptFinished() {
      // Этот колбек будет вызван из миксина, когда закончился запущенный скрипт
      if (this.isJokeEntertainmentActive) return;
      this.clearEntertainment();
    },
    goToPhotoScreen() {
      this.$router.push(this.$router.options.paths.photoTake);
    },
  },
};
</script>
